(function() { window.GUID_8a57ead1_4c9e_43eb_9489_3f31d56a90d4 = { getGuid: function() { return "8a57ead1-4c9e-43eb-9489-3f31d56a90d4"; } }; })();
//namespace CS.Controls {
//    export class GraphStats extends Graph {
//        constructor(controlId: string) {
//            super(controlId);
//            //Here the graph is initialised
//        }
//    }
//    export namespace GraphStats {
//        export class Events extends Graph.Events {
//        }
//        export class EventNames extends Graph.EventNames {
//        }
//    }
//    import that = GraphStats;
//}

//# sourceMappingURL=graph-stats.js.map
